// src/reducers/alert.reducer.js

import { alertConstants } from "../constants";

export function alert(state = {}, action) {
  if (action && action.type) {
    switch (action.type) {
      case alertConstants.SUCCESS:
        return {
          type: "alert-success",
          message: action.message,
        };
      case alertConstants.WARNING:
        return {
          type: "alert-warning",
          message: action.message,
        };
      case alertConstants.ERROR:
        return {
          type: "alert-danger",
          message: action.message,
        };
      case alertConstants.CLEAR:
        return {};
      default:
        return state;
    }
  }
}
